import { getRiskIdFromPolicyInfo } from 'containers/CourtManagerLegalProceedings/utils';
import { LISTINGS, VICTIM } from 'containers/data-structure';
import { FEATURES } from 'features/features';
import { isNil } from 'lodash';
import * as featureService from 'features/fflip-helpers';
import { getAssignedJurisdictionLawyerCode } from 'containers/RecapManagerPage/utils';

import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import { Vehicule, Victim } from 'containers/PreOpeningPage/typings';
import { get, isEmpty } from 'lodash';
import { removeWhiteSpaceFromString } from 'services/utils';
import { VictimType } from 'typings/globalTypes';

export const formatVictims = (
  victims: VictimType[],
  responsibilityRate: any,
  listings: any,
) => {
  return victims.map((victim: VictimType) => {
    let setDefaultBirthDate = false;
    if (victim[VICTIM.DATE_OF_BIRTH] === 'Invalid Date') {
      setDefaultBirthDate = true;
    }
    if (victim.injuryPostKey === INJURY_POST_DECEASED) {
      victim.nextOfKins = victim.beneficiaries.map((el: any) => {
        return {
          fullName: `${removeWhiteSpaceFromString(
            el.firstName,
          )} ${removeWhiteSpaceFromString(el.lastName)}`,
          qualityCode: Number(el.beneficiaryType),
          age: el.age,
          birthDate: el?.dateOfBirth,
          funeralFees: featureService.hasFeature(FEATURES.NEW_LAW_DAHIR)
            ? el.funeralFees
            : !isNil(el.funeralFees) && !!Number(responsibilityRate)
            ? el.funeralFees / (Number(responsibilityRate) / 100)
            : el.funeralFees,
          handicapIndicator: el.handicapIndicator ? 'Y' : 'N',
          dependentIndicator: el.dependentIndicator ? 'Y' : 'N',
        };
      });
    }
    return {
      ...victim,
      victimFirstName: victim[VICTIM.FIRST_NAME],
      victimLastName: victim[VICTIM.LAST_NAME],
      victimBirthDate: victim[VICTIM.DATE_OF_BIRTH],
      injuryCode:
        String(victim[VICTIM.INJURY_POST_KEY]) === INJURY_POST_DECEASED
          ? victim[VICTIM.INJURY_POST_KEY]
          : 0,
      qualityVictim: victim[VICTIM.QUALITY_KEY],
      classVictim: victim[VICTIM.CLASS_KEY],
      Town: victim[VICTIM.CITY],
      isExcluded: false,
      Complement: victim[VICTIM.ADDRESS],
      isWorkAccident: victim[VICTIM.WORK_ACCIDENT_ID] === 1 ? true : false,
      setDefaultBirthDate,
      cspCode: get(
        get(listings, 'Profession', []).find(
          (el: any) => el.ItemKey === victim.professionCode,
        ),
        'ItemGroup',
        null,
      ),
      gender: !isNil(victim[VICTIM.GENDER]) ? victim[VICTIM.GENDER] : '',
      responsibilityShare: responsibilityRate,
      responsibilityRate: responsibilityRate,
      itt: parseInt((victim[VICTIM.ITT] as unknown) as string),
      opposition: (((victim[VICTIM.OPPOSITION] as unknown) as string) === 'Y'
        ? 1
        : 0) as any,
    };
  });
};
export const getNoneExistingVehiculeSagis = (
  sagisClaim: any,
  policyInfo: any,
  civilProceedingInfo: any,
) => {
  const riskId = getRiskIdFromPolicyInfo(policyInfo);

  const offeredRisk = get(sagisClaim, 'offeredRisks', []).find(
    (offeredRisk: any) => offeredRisk.riskId === riskId,
  );
  const corpoVehicules = get(civilProceedingInfo, 'vehicules', []).filter(
    (vehicle: Vehicule) => {
      return !isEmpty(get(offeredRisk, 'opposingParties', []))
        ? !get(offeredRisk, 'opposingParties', []).some(
            (sagisVehicule: any) => {
              return (
                vehicle.registrationNumber.trim().toLowerCase() ===
                  sagisVehicule.registrationNumber.trim().toLowerCase() &&
                vehicle.registrationNumber.trim().toLowerCase() ===
                  sagisVehicule.registrationNumber.trim().toLowerCase()
              );
            },
          )
        : [];
    },
  );

  return corpoVehicules;
};
export const getNoneExistingVictimSagis = (
  civilProceedingInfo: any,
  sagisClaim: any,
) => {
  const sagisVictims = !isEmpty(get(sagisClaim, 'victims.Victims', []))
    ? get(sagisClaim, 'victims.Victims', [])
    : get(sagisClaim, 'victims', []);
  const corpoVictims = get(civilProceedingInfo, 'victims', []).filter(
    (victim: Victim) => {
      return !sagisVictims.some((sagisVictim: any) => {
        return (
          victim.firstName.trim().toLowerCase() ===
            sagisVictim.victimFirstName.trim().toLowerCase() &&
          victim.lastName.trim().toLowerCase() ===
            sagisVictim.victimLastName.trim().toLowerCase() &&
          victim.cin.toLowerCase() === sagisVictim.CIN.toLowerCase()
        );
      });
    },
  );
  return corpoVictims;
};
export const formatCorpoVictims = (
  civilProceedingInfo: any,
  sagisClaim: any,
) => {
  const sagisVictims = !isEmpty(get(sagisClaim, 'victims.Victims', []))
    ? get(sagisClaim, 'victims.Victims', [])
    : get(sagisClaim, 'victims', []);
  const corpoVictimsWithoutVictimKey = get(civilProceedingInfo, 'victims', [])
    .filter((item: any) => item.victimKey === '' || isNil(item.victimKey))
    .filter((victim: Victim) => {
      return sagisVictims.some((sagisVictim: any) => {
        return (
          victim.firstName.trim().toLowerCase() ===
            sagisVictim.victimFirstName.trim().toLowerCase() &&
          victim.lastName.trim().toLowerCase() ===
            sagisVictim.victimLastName.trim().toLowerCase() &&
          victim.cin.toLowerCase() === sagisVictim.CIN.toLowerCase()
        );
      });
    })
    .map((el: any) => {
      const sagisObject = sagisVictims.find((sagisVictim: any) => {
        return (
          el.firstName.trim().toLowerCase() ===
            sagisVictim.victimFirstName.trim().toLowerCase() &&
          el.lastName.trim().toLowerCase() ===
            sagisVictim.victimLastName.trim().toLowerCase() &&
          el.cin.toLowerCase() === sagisVictim.CIN.toLowerCase()
        );
      });
      return {
        ...el,
        victimKey: get(sagisObject, 'VictimKey', null),
      };
    });
  const corpoVictimsWithoutKeyID = corpoVictimsWithoutVictimKey.map(
    (item: any) => item.id,
  );
  const corpoVictimsWithVictimKey = get(
    civilProceedingInfo,
    'victims',
    [],
  ).filter((item: any) => !corpoVictimsWithoutKeyID.includes(get(item, 'id')));
  return [...corpoVictimsWithVictimKey, ...corpoVictimsWithoutVictimKey];
};
/* istanbul ignore next */
export const formatUpdateAssignementCivilProceeding = (
  info: any,
  civilProceedingInfo: any,
  lossDate: any,
  listings: any,
) => {
  const date = new Date(lossDate);
  const dayOfMonth = date.getDate();

  const lawyerJurisdictionAssignedCode = featureService.hasFeature(
    FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
  )
    ? getAssignedJurisdictionLawyerCode(
        get(listings, LISTINGS.MAPPING_LAWYER_JURISDICTION, []),
        Number(civilProceedingInfo.town),
        dayOfMonth,
      )
    : '';

  const formattedCivilProceedingInfo = {
    ...civilProceedingInfo,
    assignedLawyers: featureService.hasFeature(
      FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
    )
      ? civilProceedingInfo.status === 'PENDING' ||
        get(civilProceedingInfo, 'town') !== get(info, 'town')
        ? [lawyerJurisdictionAssignedCode]
        : get(civilProceedingInfo, 'assignedLawyers', [])
      : get(civilProceedingInfo, 'assignedLawyers', []),
  };
  let existedAssignement = get(
    info,
    'assignment',
    [],
  ).filter((el: { assignedLawyer: string; id: number }) =>
    get(formattedCivilProceedingInfo, 'assignedLawyers', []).includes(
      el.assignedLawyer,
    ),
  );
  let deletedAssignement = get(info, 'assignment', []).filter(
    (el: { assignedLawyer: string; id: number }) =>
      !get(formattedCivilProceedingInfo, 'assignedLawyers', []).includes(
        el.assignedLawyer,
      ),
  );
  let newAssignement = get(
    formattedCivilProceedingInfo,
    'assignedLawyers',
    [],
  ).filter(
    (item: string) =>
      get(formattedCivilProceedingInfo, 'assignedLawyers', []).includes(item) &&
      !existedAssignement?.map((el: any) => el.assignedLawyer).includes(item),
  );
  if (!isEmpty(deletedAssignement)) {
    deletedAssignement = deletedAssignement.map(
      (el: { assignedLawyer: string; id: number }) => ({
        ...el,
        toDelete: true,
      }),
    );
  }
  if (!isEmpty(newAssignement)) {
    newAssignement = newAssignement.map((item: string) => ({
      assignedLawyer: item,
    }));
  }
  return [...existedAssignement, ...deletedAssignement, ...newAssignement];
};
